import React, { Component, useCallback, useState } from 'react'
import { connect } from 'react-redux';
import { notesActions } from '../actions/notes.actions';
// eslint-disable-next-line
import { Button, Input, List, Row, Col, Alert, Spin, Checkbox, Tooltip, Popover, Icon, Form } from 'antd';
import { dspxSorter } from '../helpers/dspx-sort';
import { linkify } from '../helpers/linkify';
import { CommentIcon } from '../resource/icons';
import moment from 'moment';

const CHAR_LIMIT = 3000;

class NotesPanelContainer extends Component {
	constructor(props) {
		super(props)

		this.state = {
			note: '',
			availableForClient: this.props.userInfo.DefaultCommentVisibility,
			notes: [],
			dataFetching: false,
			commentAwait: false,
			formVisible: false,
			editNoteLoading: [],
			editFormVisible: null,
		}
	}

	handleChangeNote = (e) => {
		this.setState({ note: e.target.value })
	}

	formOk = () => {
		this.setState({ formVisible: false })

		const noteData = {
			note: this.state.note.replace(/"/g,'\\"'),
			availableForClient : this.state.availableForClient ? 1 : 0,
		}
		notesActions.postNote(noteData, this.props.request)
			.then( () => {
				this.setState({ note: '' })
				this.getNotesList()
				this.props.onPostComment && this.props.onPostComment(this.props.request)
			},
			err => { this.setState({ dataFetching: false }); console.log(err) })
	}

	formHide = () => {
		this.setState({ formVisible: false, note: '' })
	}

	handleFormVisibleChange = (formVisible) => {
		const data = { formVisible }
		if (!formVisible) {
			data.note = '';
		}
		this.setState(data);
	}

	handleEditFormVisibleChange = (id) => (visible) => {
		this.setState(() => ({ editFormVisible: visible ? id : null }));
	}

	handleNewNoteCheckboxClick = (e) => {
		this.setState({ availableForClient: e.target.checked })
	}

	handleShowToClient = async (id,isVisible) => {
		this.setState({ commentAwait: true })

		notesActions.setNoteVisibility(id, isVisible)
			.then( () => {
				const _notes = this.state.notes.slice()
				const _idx = _notes.findIndex((e)=>e.id==id)
				const _note = _notes[_idx]
				_note.availableForClient=isVisible
				_notes[_idx]=_note
				this.setState({ commentAwait: false, notes: _notes })
			},
			err => {
				this.setState({ commentAwait: false })
				console.log(err)
			})
	}


	getNotesList = () => {

		this.setState({ dataFetching: true })

		notesActions.fetchNotes(this.props.request)
			.then(
				data => {
					//const n = data.data.map((el)=>({id: el.id, user: el.user, note: el.note, date: el.date+' pm'}));
					data.data.sort(dspxSorter.sorterDateDesc);

					this.setState({ notes: data.data, dataFetching: false })
				},
				err => { this.setState({ dataFetching: false }); console.log(err) })
	}

	componentDidMount() {

		if (this.props.isnotes) this.getNotesList();
	}

	componentDidUpdate(prev) {
		if (
      prev.request != this.props.request ||
      this.props.needUpdate
    ) {
      this.getNotesList();

      if (
        this.props.needUpdate &&
        typeof this.props.resetNeedUpdate === 'function'
      ) {
        this.props.resetNeedUpdate();
      }
    }
	}

	render() {
		const hasExceededLimit = this.state.note?.length > CHAR_LIMIT;

		const noteForm = <div style={{ textAlign: 'right', width: '400px' }}>
			<TextAreaField
				value={this.state.note}
				onChange={this.handleChangeNote}
				hasExceededLimit={hasExceededLimit}
			/>
			<Checkbox style={{ marginBottom: 10, marginRight: '10px' }}
			  checked={this.state.availableForClient}
				disabled={this.state.note.length < 1}
				onClick={this.handleNewNoteCheckboxClick}>
					Показывать собственнику
    	</Checkbox>
			<Button onClick={this.formHide} style={{ marginRight: '10px' }}>Отмена</Button>
			<Button onClick={this.formOk} disabled={this.state.note.length < 1 || hasExceededLimit} type="primary">OK</Button>
		</div>

		const EditNoteForm = ({ item }) => {
			const [value, setValue] = useState(item.note);

			const hasExceededLimit = value?.length > CHAR_LIMIT;

			const hide = useCallback(() => {
				this.setState(() => ({ editFormVisible: null }));
			}, []);

			const submit = useCallback(() => {
				hide()
				this.setState(({ editNoteLoading }) => editNoteLoading.push(item.id));
				notesActions.editNote(item.id, value)
					.then(() => {
						this.getNotesList()
					})
					.finally(() => {
						this.setState(({editNoteLoading}) => {
							const index = editNoteLoading.indexOf(item.id)
							const newIds = editNoteLoading.slice()
							newIds.splice(index, 1)

							return {
								editNoteLoading: newIds,
								dataFetching: false,
							}
						});
					})
			}, [value, hide]);

			return (
				<div style={{ textAlign: 'right', width: '400px' }}>
					<TextAreaField
						value={value}
						onChange={({ target }) => setValue(target.value)}
						hasExceededLimit={hasExceededLimit}
					/>
					{/*<Checkbox*/}
					{/*	style={{ marginBottom: 10, marginRight: '10px' }}*/}
					{/*	value={item.availableForClient}*/}
					{/*	onClick={this.handleNewNoteCheckboxClick}*/}
					{/*>*/}
					{/*	Показывать собственнику*/}
					{/*</Checkbox>*/}
					<Button onClick={hide} style={{ marginRight: '10px' }}>Отмена</Button>
					<Button onClick={submit} disabled={value.length < 1 || value === item.note || hasExceededLimit} type="primary">OK</Button>
				</div>
			)
		}

		const isAccessAddNote = this.props.canChange && this.props.userInfo.CanAddNoteToRequest

		return (
			<div style={{ marginBottom: '20px' }}>
				{this.props.apiResponseError && <Alert message={this.props.apiResponseText} type="error" showIcon />}

				{/*<div>
			<span style={{ color:'#aaa' }}>Комментарии</span>
			<span style={{ marginLeft:'10px', color:'#999' }}><Icon type="plus-circle" theme="outlined" /></span>
			</div>*/}

				<Row gutter={8}>
					<Col span={2}>
						{isAccessAddNote && (
              <Popover
                content={noteForm}
                title="Комментарий"
                trigger="click"
                placement="bottomRight"
								autoAdjustOverflow={false}
                onVisibleChange={this.handleFormVisibleChange}
                visible={this.state.formVisible}
              >
                <Tooltip
                  mouseLeaveDelay={0}
                  title="Добавить комментарий"
                >
                  <Button
                    ghost
                    shape="circle"
                    style={{ fontSize: '10px', marginTop: '0px' }}
                  >
                    <CommentIcon
                      nogrey={(this.state.notes.length === 0).toString()}
                      style={{ height: '22px', marginTop: '0px' }}
                    />
                  </Button>
                </Tooltip>
              </Popover>
            )}
						
					</Col>
					<Col span={22} >
						<Spin size="large" spinning={this.state.dataFetching} tip="Загрузка..." delay={100}>
							{(this.state.notes && this.state.notes.length > 0 &&
								<List style={{ marginTop: '0px' }} className='dspx-notes-list'
									itemLayout="vertical"
									size="small"
									bordered={false}
									pagination={{
										hideOnSinglePage: true,
										pageSize: 5,
										size: 'small',
									}}
									dataSource={this.state.notes}
									renderItem={item => {
										const dt = moment(item.date);
										const editVisible = item.canBeEdited && this.props.canChange;

										return (
											<List.Item key={item.id} className={ item.availableForClient ? 'dspx-notes-item client-visible' : 'dspx-notes-item'} >
												<Row align="middle">
													<Col span={19}>
														<div
                              style={{
                                fontSize: '10px',
                                display: 'flex',
                                alignItems: 'flex-start',
                              }}
                            >
															<span>{dt.format('DD.MM.YYYY HH:mm:ss')}</span>
															<div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  marginLeft: '10px',
                                }}
                              >
                                {item.user.specialityName && (
                                  <span
                                    style={{ fontWeight: 700, lineHeight: 1, fontSize: '8px' }}
                                  >
                                    {item.user.specialityName}
                                  </span>
                                )}
                                <span>
                                  {item.user.surName +
                                    (item.user.firstName
                                      ? ' ' +
                                        item.user.firstName.substring(0, 1) +
                                        '.'
                                      : '') +
                                    (item.user.patrName
                                      ? ' ' +
                                        item.user.patrName.substring(0, 1) +
                                        '.'
                                      : '')}
                                </span>
                              </div>
															
															{item.edited && <span style={{marginLeft: 6, color: '#888888', fontSize: 8}}>изменено</span>}
														</div>
														<div
															style={{ fontSize: '13px', color: '#4d5974' }}
															dangerouslySetInnerHTML={{
																__html: linkify(item.note || ''),
															}}
														/>
														{!item.fromClientNote &&
                              !item.availableForClient && (
                                <div
                                  style={{
                                    fontSize: '11px',
                                    color: 'silver',
                                    marginTop: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                  }}
                                >
                                  <Icon
                                    type="eye-invisible"
                                    style={{ marginTop: 0 }}
                                  />
                                  Скрыто от собственника
                                </div>
                              )}
													</Col>

													{ !item.fromClientNote &&
													<Col span={5} style={{textAlign:"right", }} className="vertical-center-right">
														{/* item.availableForClient ? <Icon type='eye' className='dspx-note-eye' /> : <Icon type='eye-invisible' className='dspx-note-eye' />  */}
														{/* { item.availableForClient && <Icon type='eye' className='dspx-note-eye' style={{margin: 3}} /> } */}
														{editVisible && (
															<>
																<Icon type="edit" className="dspx-note-eye" style={{ margin: 3 }} />
																<Tooltip
																	title={
																		item.availableForClient
																			? 'Не показывать собственнику'
																			: 'Показывать собственнику'
																	}
																	placement="left"
																>
																	<Button
																		shape="circle"
																		icon={
																			this.state.commentAwait
																				? 'loading'
																				: item.availableForClient
																				? 'eye-invisible'
																				: 'eye'
																		}
																		className={
																			item.availableForClient
																				? 'dspx-notes-hide-for-client-button'
																				: 'dspx-notes-show-to-client-button'
																		}
																		onClick={
																			!this.state.commentAwait
																				? (e) => {
																						e.stopPropagation();
																						this.handleShowToClient(
																							item.id,
																							!item.availableForClient
																						);
																					}
																				: null
																		}
																	/>
																</Tooltip>
																{isAccessAddNote && (
																	<Popover
																		content={<EditNoteForm item={item} />}
																		title="Редактировать комментарий"
																		trigger="click"
																		placement="right"
																		onVisibleChange={this.handleEditFormVisibleChange(
																			item.id
																		)}
																		visible={
																			this.state.editFormVisible === item.id
																		}
																	>
																		<Tooltip
																			mouseLeaveDelay={0}
																			title="Редактировать комментарий"
																		>
																			<Button
																				style={{ marginLeft: 4 }}
																				shape="circle"
																				icon={
																					this.state.editNoteLoading.includes(
																						item.id
																					)
																						? 'loading'
																						: 'edit'
																				}
																				className="dspx-notes-show-edit-button"
																			/>
																		</Tooltip>
																	</Popover>
																)}
													
															</>
														)}
													</Col>
													}
												</Row>
											</List.Item>
										)
									}}
								/>)
							|| <div style={{ marginTop: '8px', fontSize: '11px', color: '#ccc' }}>нет комментариев</div>}
						</Spin>
					</Col>
				</Row>
			</div>
		)
	}
}

NotesPanelContainer.defaultProps = {
  canChange: true,
};

function mapStateToProps(state) {
	const { notesStore } = state;
	const { userInfo } = state.authentication;
	return { notesStore, userInfo };
}

export default connect(mapStateToProps)(NotesPanelContainer);

function TextAreaField({ value, onChange, hasExceededLimit }) {
  return (
    <Form.Item
      validateStatus={hasExceededLimit ? 'error' : undefined}
      help={
        <Help
          hasExceededLimit={hasExceededLimit}
          valueLength={value?.length || 0}
        />
      }
      style={{ marginBottom: 10, textAlign: 'left' }}
    >
      <Input.TextArea
        onChange={onChange}
        value={value}
        autoSize={{ minRows: 1, maxRows: 3 }}
      />
    </Form.Item>
  );
}

function Help({ hasExceededLimit, valueLength }) {
  return (
    <span
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 10,
        lineHeight: 1.1,
        marginTop: 4,
      }}
    >
      {hasExceededLimit && 'Превышен лимит допустимого количества символов'}
      <span style={{ color: 'rgba(0, 0, 0, 0.45)', marginLeft: 'auto' }}>
        {valueLength || 0}/{CHAR_LIMIT}
      </span>
    </span>
  );
}